module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn_case_next-192b4a202aa4b9f5cd587578598ace05.svg";